import React, { PropTypes } from 'react';
import { FieldArray, formValueSelector, initialize, reduxForm, SubmissionError } from 'redux-form';
import { Button } from 'react-bootstrap';
import { connect } from 'react-redux';
import alert from 'alertify.js';
import axios from './../../../constants/axios';
import RenderLists from './Helper/RenderLists';

class EditPurchaseForm extends React.Component {
   constructor(props) {
      super(props);
      this.state = {
         invoiceDetails: {},
         loading: false,
      };
   }

   componentDidMount() {
      this.loadInvoiceDetails();
      this.getInvoiceInventoryItems();
   }

   componentWillReceiveProps(nextProps) {
      if (nextProps.items && nextProps.items.length > 0) {
         nextProps.items.forEach((item) => {
            if (item.total && item.unit) {
               item.price = (item.total / item.unit).toFixed(5);
            } else {
               item.price = '';
            }
         });
      }
   }

   getInvoiceInventoryItems = () => {
      const { invoiceId } = this.props.params;
      axios.get(`inventorySales/getInventoryItemsByInvoiceId/${invoiceId}`)
         .then((res) => {
            this.props.dispatch(initialize('inventoryPurchaseEditForm', {
               items: res.data.items
            }));
         });
   };


   loadInvoiceDetails = () => {
      const { invoiceId } = this.props.params;
      this.setState({
         loading: true,
      });
      axios.get(`inventoryPurchases/getInvoiceSimpleInfoById/${invoiceId}`)
         .then((res) => {
            this.setState({
               invoiceDetails: res.data,
               loading: false,
            });
         });
   };

   submit = (values) => {
      const dataToSend = {
         items: values.items.map((i) => {
            return {
               item_id: i.item_id,
               unit: i.unit,
               price: i.price,
            };
         })
      };
      const { invoiceId } = this.props.params;
      return axios.put('/inventoryPurchases/editPurchaseItems/' + invoiceId, dataToSend)
         .then((res) => {
            if (res.status === 201) {
               alert.success('invoice created.');
               this.context.router.push('/purchase/purchaseInvoiceDetail/' + invoiceId);
            } else {
               alert.error('Something went unexpected. Call Rasel.');
            }
         })
         .catch((err) => {
            if (err.response.status === 422) {
               throw  new SubmissionError(err.response.data);
            } else {
               alert.error('Something not right. Rasel, where are you?');
            }
         });
   };

   render() {
      const { handleSubmit, items, submitting, pristine, invalid, error } = this.props;
      const { invoiceId } = this.props.params;
      const { invoiceDetails } = this.state;

      const total = function () {
         let subTotal = 0;
         if (items && items.length > 0) {
            items.forEach((item) => {
               subTotal += (item.unit || 0) * (item.price || 0);
            });
         }
         return subTotal.toFixed(5);
      };

      return (
         <form noValidate autoComplete="off" onSubmit={() => {
         }} >
            <h3 >Edit Purchase Invoice: {invoiceId}</h3 >
            <div className="row" >
               <p >Vendor Name: {invoiceDetails.name}</p >
               <p >Memo: {invoiceDetails.memo}</p >
            </div >
            <FieldArray items={items} name="items" component={RenderLists} />

            <hr />
            <p className="pull-right" >Total: {total()}</p >
            <hr />
            {error && <strong className="input-validation-error" >{error}</strong >}

            <Button type="button" bsStyle="success" block
                    onClick={handleSubmit(this.submit)}
                    disabled={submitting || pristine || invalid} >UPDATE</Button >
         </form >
      );
   }
}

EditPurchaseForm.propTypes = {
   handleSubmit: PropTypes.func,
   submit: PropTypes.func,
   items: PropTypes.array,
   submitting: PropTypes.bool,
   pristine: PropTypes.bool,
   invalid: PropTypes.bool,
   error: PropTypes.oneOfType([
      PropTypes.object,
      PropTypes.string
   ]),
   contact_id: PropTypes.oneOfType([
      PropTypes.object,
      PropTypes.number
   ]),
   params: PropTypes.oneOfType([
      PropTypes.object,
   ]),
   dispatch: PropTypes.func,
};

EditPurchaseForm.contextTypes = {
   router: PropTypes.object
};

EditPurchaseForm = reduxForm({ // eslint-disable-line
   form: 'inventoryPurchaseEditForm'
})(EditPurchaseForm);

const selector = formValueSelector('inventoryPurchaseEditForm');

EditPurchaseForm = connect(state => { // eslint-disable-line
   const items = selector(state, 'items');
   const contact_id = selector(state, 'contact_id');
   return {
      items,
      contact_id
   };
})(EditPurchaseForm);


export default EditPurchaseForm;






/** WEBPACK FOOTER **
 ** ./src/components/InvoiceManagement/Purchase/EditPurchaseForm.js
 **/